// Third party libraries
import PropTypes from 'prop-types';
// Styles
import styles from './DepartmentRadiobuttonsec.module.css';

export const DepartmentRadiobuttonsec = (props) => {
  const { title, name, isChecked, onChangeValue, firstValue, secondValue } = props;
  return(
    <label className={styles.inputContainer}>
      <p className={styles.inputName}>{title}</p>
      <p className={styles.radiobtnContainer}>
        <input
          type='radio'
          value={true}
          name={name}
          checked={isChecked}
          onChange={onChangeValue}
        />
        {firstValue}
        <input
        className={styles.radio}
          type='radio'
          value={false}
          name={name}
          checked={!isChecked}
          onChange={onChangeValue}
        />
        {secondValue}
      </p>
    </label>
  );
};

DepartmentRadiobuttonsec.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onChangeValue: PropTypes.func.isRequired,
  firstValue: PropTypes.string.isRequired,
  secondValue: PropTypes.string.isRequired,
}
